import { useContext, useEffect, useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Tooltip,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AddIcon from "@material-ui/icons/Add";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";

import {
  HeaderAccordion,
  TableContent,
  IconButtonStyled,
} from "../styles/Cliente";
import useClienteController from "../controllers/ClienteController";
import TableDefault from "../../../../components/grid/TableDefault";
import MaskService from "../../../../utils/mask/maskService";
import { ClienteContext } from "../contexts/ClienteContext";
import ModalClienteAutorizado from "./ModalClienteAutorizado";
import Chip from "../../../../components/basics/Chip";
import SpeedDialErp from "../../../../components/speeddial/SpeedDialErp";
import { DeleteOutlined } from "@material-ui/icons";

const columns = [
  {
    id: "acoes",
    label: "Ações",
    align: "center",
  },
  {
    id: "nomeautorizado",
    label: "Nome",
  },
  {
    id: "apelido",
    label: "Apelido",
  },
  {
    id: "endereco",
    label: "Endereço",
  },
  {
    id: "telefone1",
    label: "Telefone",
    align: "center",
  },
];

export default function AccordionClienteAutorizado() {
  const { expanded, authorized, setAuthorized, errors } =
    useContext(ClienteContext);
  const {
    handleChangeOpenAcordion,
    handleRemoveItemTable,
    handleEditItemTable,
  } = useClienteController();
  const [open, setOpen] = useState(false);
  const [rowEdit, setRowEdit] = useState(null);
  const [dataTable, setDataTable] = useState([]);

  useEffect(() => {
    (async () => {
      const newList = [];
      authorized.forEach(
        (item, index) =>
          (newList[index] = {
            ...item,
            telefone1: MaskService.toMask(
              "cel-phone",
              `${item.ddd1 || ""}${item.telefone1 || ""}`
            ),
            telefone2: MaskService.toMask(
              "cel-phone",
              `${item.ddd2 || ""}${item.telefone2 || ""}`
            ),
            acoes: (
              <SpeedDialErp
                actions={[
                  {
                    icon: <EditOutlinedIcon />,
                    name: "Editar",
                    action: () =>
                      handleEditItemTable(setOpen, setRowEdit, item, index),
                  },
                  {
                    icon: <DeleteOutlined />,
                    name: "Excluir",
                    action: () =>
                      handleRemoveItemTable(
                        setAuthorized,
                        setDataTable,
                        authorized,
                        index
                      ),
                  },
                ]}
              />
            ),
          })
      );

      setDataTable(newList);
    })();
  }, [authorized, setAuthorized, handleEditItemTable, handleRemoveItemTable]);

  return (
    <>
      {open && (
        <ModalClienteAutorizado
          open={open}
          setOpen={setOpen}
          setRowEdit={setRowEdit}
          rowEdit={rowEdit}
        />
      )}
      <Grid item xs={12}>
        <Accordion expanded={expanded.authorized || false}>
          <AccordionSummary
            expandIcon={
              <ExpandMoreIcon
                onClick={() => handleChangeOpenAcordion("authorized")}
              />
            }
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container spacing={1} alignItems="center">
                <Grid
                  item
                  xs
                  onClick={() => handleChangeOpenAcordion("authorized")}
                >
                  <Chip
                    label="AUTORIZADOS"
                    bgcolor={
                      !expanded.authorized &&
                      errors.accordions &&
                      errors.accordions.includes("authorized")
                        ? "red"
                        : "default"
                    }
                  />
                </Grid>
                <Grid item flex={1}>
                  <Tooltip title="Adicionar Autorizado">
                    <IconButtonStyled onClick={() => setOpen(true)}>
                      <AddIcon />
                    </IconButtonStyled>
                  </Tooltip>
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>

          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TableContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TableDefault
                        columns={columns}
                        values={dataTable}
                        tableTitle=""
                      />
                    </Grid>
                  </Grid>
                </TableContent>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
}
